var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-full w-full flex flex-col justify-center items-center bg-black",on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"w-auto bg-black",attrs:{"id":"loading-animation"}},[_c('img',{attrs:{"src":"/cycraft/cycraft-loading-min.gif","alt":"loading animation","draggable":false}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }